import { TFunc } from 'libs/i18n';
import { renderClientStatus } from 'modules/client/common/helpers';

import { ClientsListItem } from '../../../types';

export const renderStatus = (item: ClientsListItem, t: TFunc) =>
  renderClientStatus({ ...item, status: item.onboardingStatus }, t, {
    size: 'm',
  });
